import { calculateCheckDigit } from '../../../utils/order-utils';
export var orderNumberFormat = function (orderNumber, transactionId, registerNumber, showTextLabel, customerType) {
    if (showTextLabel === void 0) { showTextLabel = true; }
    if ((!orderNumber || orderNumber === 'undefined') &&
        Boolean(transactionId) &&
        Boolean(registerNumber)) {
        return "".concat(showTextLabel ? 'Receipt ' : '', "# ").concat(instoreOrderNumberFormat(registerNumber, transactionId, customerType));
    }
    if (orderNumber === null || orderNumber === undefined) {
        return 'Order Number Unavailable';
    }
    if (orderNumber === null || orderNumber === void 0 ? void 0 : orderNumber.includes('-')) {
        return "".concat(showTextLabel ? 'Receipt ' : '', "# ").concat(orderNumber);
    }
    return "".concat(showTextLabel ? 'Order ' : '', "# ").concat(orderNumber);
};
export var instoreOrderNumberFormat = function (registerNumber, transactionId, customerType) {
    if (!registerNumber || !transactionId) {
        return '';
    }
    var registerNumberStr = (registerNumber === null || registerNumber === void 0 ? void 0 : registerNumber.toString()) || '';
    var transactionIdStr = (transactionId === null || transactionId === void 0 ? void 0 : transactionId.toString()) || '';
    var paddedRegisterNumber = registerNumberStr.padStart(5, '0');
    var paddedTransactionId = transactionIdStr.padStart(5, '0');
    if (customerType === 'b2c') {
        var transIdWithCheckDigit = transactionIdStr +
            calculateCheckDigit(registerNumberStr, transactionIdStr.padStart(4, '0'));
        return "".concat(paddedRegisterNumber, "-").concat(transIdWithCheckDigit.padStart(5, '0'));
    }
    return "".concat(paddedRegisterNumber, "-").concat(paddedTransactionId);
};
/**
 * Should have same logic as orderNumberFormat() above
 * Includes both CashNCarry and H Orders
 * @param orderNumber
 * @param transactionId field that is used for cashNCarry and some H order types
 * @param registerNumber field that is used for cashNCarry and some H order types
 * @returns true if the order number is in the store format and therefore should be treated as a receipt number
 */
export var isInStoreOrderNumber = function (orderNumber, transactionId, registerNumber) {
    if ((!orderNumber || orderNumber === 'undefined') &&
        Boolean(transactionId) &&
        Boolean(registerNumber)) {
        return true;
    }
    if (orderNumber === null || orderNumber === undefined) {
        return false;
    }
    if (orderNumber === null || orderNumber === void 0 ? void 0 : orderNumber.includes('-')) {
        return true;
    }
    return false;
};
/**
 * Determines if the order is a CashNCarry order based on if order number starts with a number and order origin is not online
 * @param orderNumber
 * @param orderOrigin OMS field that indicates where the order originated from, can be either online or store number
 * @returns true if the order is a CashNCarry order, false otherwise
 */
export var isCashNCarryOrder = function (orderNumber, orderOrigin, registerNumber, transactionId) {
    var parsedOrderNumber = orderNumber;
    if (!parsedOrderNumber || parsedOrderNumber === 'undefined') {
        parsedOrderNumber = instoreOrderNumberFormat(registerNumber, transactionId);
    }
    var firstCharIsNumber = /^[0-9]/.test(parsedOrderNumber);
    var containsHyphen = parsedOrderNumber.includes('-');
    return firstCharIsNumber && containsHyphen && orderOrigin !== 'online';
};
